import React from 'react';
import { useSelector } from 'react-redux';
import Categories from '../Categories/Categories';

const HomeCategories = () => {
  const categoryList = useSelector((state) => state.categories.list);

  return <Categories products={categoryList} title="Категорії товарів" />;
};

export default HomeCategories;
